import { Action } from '@ngrx/store';

export enum OrderAvailableActionTypes {
  ORDER_AVAILABLE = '[Rms Order Avilable] order Availability',
  RESET = '[Rms Order Avilable] Reset',
}

export class LoadOrderAvailabilityAction implements Action {
  readonly type = OrderAvailableActionTypes.ORDER_AVAILABLE;

  constructor(public payload: boolean) {}
}

export class ResetOrderAvailabilityAction implements Action {
  readonly type = OrderAvailableActionTypes.RESET;

  constructor() {}
}

export type OrderAvailableTypes = LoadOrderAvailabilityAction | ResetOrderAvailabilityAction;
